import { Box } from "@mui/material";
import React, { useRef } from "react";
import { ediphiPalette } from "../../styles/colors";

const Header: React.FC = () => {
  const headerRef = useRef<HTMLDivElement>(null);
  const logo = "assets/ediphi_logo_wordmark.svg";

  return (
    <Box
      component="section"
      ref={headerRef}
      sx={{
        width: "100%",
        height: "50px",
        padding: "10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: ediphiPalette.surface,
      }}
    >
      <Box
        component="img"
        src={logo}
        alt="Ediphi Logo"
        sx={{
          height: "30px", // Adjust height for logo
          width: "auto",
        }}
      />
    </Box>
  );
};

export default Header;
